<template>
  <tr
    v-if="!dataRow.isHide"
    :class="['tr-group ms-tr', dataRow.IsBold ? 'ms-format-bold' : '', dataRow.IsItalic ? 'ms-format-italic' : '']"
  >
    <td v-if="multiple && isShowMultiple" class="ms-td multiple-cell sticky ms-col-td-multiple">
      <ms-checkbox
        ref="multiple"
        :key="0"
        :checked="isChecked"
        class="justify-center"
        check-only
        @input="checkMultiple"
      />
    </td>
    <td
      v-for="(col, index) in columnSumary"
      :key="index"
      :colspan="col.groupColspan"
      class="ms-td ms-col-td"
      :field="col.dataField"
      :class="[
        index === columnSumary?.length - 1 ? 'ms-col-td-last' : '',
        index === 0 ? 'sticky-row-group' : '',
        col.lock ? 'sticky' : '',
      ]"
      :style="styleWidth(col, false)"
    >
      <div class="flex-row" :class="`level-${dataRow.level}`">
        <div
          v-if="isExpand && index === 0"
          class="pointer"
          :class="[dataRow.expanded ? 'expand' : 'collapse']"
          @click="toggle_click"
        />
        <div :class="[`text-${col.align || 'left'}`, col.cssClass, 'text-overflow', 'content-cell text-overflow']">
          <span
            v-if="col.formatType === $ms.constant.FormatType.Checkbox"
            :ref="`text-${col.dataField}`"
            class="cell-checkbox"
          >
            <div class="icon" :class="{checked: dataRow[col.dataField]}" />
          </span>

          <span
            @click="groupRowClick(col)"
            v-else
            :ref="`text-${col.dataField}`"
            :class="[`text-${col.align || 'left'}`, col.cssClass]"
          >
            {{
              $ms.format.formatData(dataRow[col.dataField], {
                formatType: col.formatType,
                optionFormat: col.optionFormat,
                enumName: col.enum,
                isShowZero: isShowZero,
              })
            }}
          </span>
          <template v-if="$slots['caption-group-extend']">
            <slot name="caption-group-extend" :colIndex="index" />
          </template>
        </div>
      </div>
    </td>

    <td v-if="$slots.widget" :key="100" class="ms-td widget-item sticky">
      <slot name="widget" />
    </td>
  </tr>
</template>

<script>
import {computed, watch} from 'vue';
export default {
  props: {
    isShowZero: {
      default: true,
      type: Boolean,
    },
    col: {
      default: () => [],
      type: Object,
    },
    columnSumary: {
      default: () => [],
      type: Array,
    },
    dataRow: {
      default: () => {},
      type: Object,
    },
    // Ẩn/hiện cột checkbox tích chọn nhiều cột
    multiple: {
      default: false,
      type: Boolean,
    },
    isShowMultiple: {
      default: false,
      type: Boolean,
    },
    isCheckedAll: {
      default: () => false,
      type: Boolean,
    },
    // Trạng thái tích chọn ở cột multiple
    isSelected: {
      default: false,
      type: Boolean,
    },
    /**
     * có cho phép expand/collapse ở không
     * nhhoang1 22.09.2023
     */
    isExpand: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['toogleTree', 'clickMultipleGroup', 'groupRowClick'],
  setup(props, {emit}) {
    const toggle_click = () => {
      emit('toogleTree', props.dataRow);
    };
    // sự kiện click vào dòng cha - htthoa: 18.10.2023
    // bổ sung thêm col để phân biệt col được click - kbnguyet 20.03.2024
    const groupRowClick = col => {
      emit('groupRowClick', props.dataRow, col);
    };

    /**
     * Nếu có check all sẽ thực hiện check all
     */
    const isChecked = computed(() => {
      return props.isCheckedAll || props.isSelected;
    });

    return {toggle_click, isChecked, groupRowClick};
  },
  methods: {
    /**
     * Click checkbox
     * NXCHIEN 21.10.2022
     */
    checkMultiple(e) {
      const me = this;
      const checked = e.target.tagName.toLowerCase() === 'input' ? e.target.checked : false;
      this.$emit('clickMultipleGroup', this.dataRow, checked);
    },

    /**
     * Cập nhật lại độ rộng của cột theo độ rộng cấu hình
     * vqphong - 29/11/2023
     */
    styleWidth(col, widget) {
      const rs = {};

      if (col.lock) {
        rs.left = (col.stickyOffset || 0) + 'px';
      }

      if (!widget) {
        rs['max-width'] = col.width + 'px';
      }
      // this.$emit('styleColumn', col, this.dataRow, rs);

      return rs;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/components/MsTrViewer.scss';
.ms-format-bold {
  font-weight: $font-weight-bold;
}
.ms-format-italic {
  font-style: italic;
}

.tr-group {
  ::deep(.widget-container) {
    display: none;
  }

  .ms-col-td.sticky {
    position: sticky;
  }
}

.pointer {
  height: 24px;
  width: 24px;
  position: relative;
  margin-right: 6px;
  &.expand {
    &:before {
      content: '';
      background: transparent $ms-image-sprites no-repeat;

      position: absolute;
      top: 0;
      left: 0;
      height: 24px;
      width: 24px;
      background-position: -216px -360px;
    }
  }

  &.collapse {
    &:before {
      content: '';
      background: transparent $ms-image-sprites no-repeat;

      position: absolute;
      top: 0;
      left: 0;
      height: 24px;
      width: 24px;
      background-position: -192px -360px;
    }
  }
}
.content-cell {
  line-height: 24px !important;
}
</style>
